module.exports = __webpack_public_path__ + "images/1f7e27c34b548503d00e479aae710070a.svg";